import { toRUDate } from '@/utilities';


class Message {
  constructor(data) {
    this.id = data.id;
    this.type = data.message_type;
    this.created = new Date(data.created);
    this.createdDateString = toRUDate(this.created);
    this.text = data.text;
    this.unread = data.unread;
    this.appointment = data.appointment;
  }

  /**
   * Returns time in HH:MM format
   */
  getTime() {
    return this.created.toTimeString().substring(0, 5);
  }

  /**
   * Returns date in day with month format
   */
  getDay() {
    return this.created.toLocaleString("ru", {
      month: "long",
      day: "numeric"
    });
  }

  getMessageType() {
    return {
      "-1": "client",
      "0": "system",
      "1": "notary"
    }[this.type];
  }
}
export default Message;
